import { DownOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { AssistantStats } from "../../../api/assistant";

// Малкият ред под отговора: време, стъпки, цена; „Детайли" разгъва токените
// и кои инструменти/раздели са ползвани. По подразбиране е свит.
export const AssistantStatsLine = ({ stats }: { stats: AssistantStats }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const cost = stats.costUsd !== null ? Number(stats.costUsd) : null;

  return (
    <div className="flex flex-col gap-[6px]">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        className="inline-flex cursor-pointer items-center gap-[6px] self-start rounded-md border-none bg-transparent px-[4px] py-[2px] font-pos-mono text-[11px] tabular-nums text-muted transition-colors duration-150 hover:bg-shade-1 hover:text-ink"
      >
        {t("monitoring.assistantStatsSummary", { seconds: stats.seconds, rounds: stats.rounds })}
        {cost !== null && Number.isFinite(cost) && (
          <span>· {t("monitoring.assistantStatsCost", { cost: cost.toFixed(4) })}</span>
        )}
        <DownOutlined
          className={`!text-[9px] transition-transform duration-150 ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && (
        <div className="flex flex-col gap-[4px] rounded-[10px] bg-canvas px-[12px] py-[10px] font-pos-mono text-[11px] leading-[1.5] tabular-nums text-muted">
          <div>
            {t("monitoring.assistantStatsTokens", {
              tokensIn: stats.tokensIn,
              cacheRead: stats.cacheRead,
              tokensOut: stats.tokensOut,
              model: stats.model,
            })}
          </div>
          {stats.tools.length > 0 && (
            <>
              <div className="mt-[4px] font-pos-sans text-[10.5px] font-bold uppercase tracking-[1.2px]">
                {t("monitoring.assistantStatsTools")}
              </div>
              <ul className="m-0 flex list-none flex-col gap-[2px] p-0">
                {stats.tools.map((tool, index) => (
                  <li key={index} className="break-all">
                    {tool}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  );
};
